import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15",
  fill: "none"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M14 7.405a7 7 0 1 0-8.094 6.915V9.428H4.13V7.404h1.777V5.863c0-1.754 1.046-2.724 2.645-2.724.765 0 1.566.137 1.566.137V5h-.883c-.87 0-1.14.54-1.14 1.093v1.313h1.94l-.31 2.024h-1.63v4.891A7 7 0 0 0 14 7.405"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }